const STORAGE_KEY = "rutter:netsuite:embedded-setup";
let inMemoryToken = "";

// Run before analytics initialization so the bearer ticket cannot enter page URLs.
export function captureNetsuiteSetupToken(): string {
  if (window.location.pathname !== "/netsuite/embedded-setup") return "";
  const token = new URLSearchParams(window.location.hash.slice(1)).get(
    "setup_token",
  );
  if (token && /^[a-f0-9]{64}$/.test(token)) {
    inMemoryToken = token;
    window.history.replaceState(null, "", window.location.pathname);
    try {
      sessionStorage.setItem(STORAGE_KEY, token);
    } catch {
      /* memory-only when storage is unavailable */
    }
  }
  try {
    return inMemoryToken || sessionStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return inMemoryToken;
  }
}

export function clearNetsuiteSetupToken() {
  inMemoryToken = "";
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage may be disabled */
  }
}
